$(document).ready(function () {
  function AddReadMore() {
    var carLmt = 250;
    var readMoreTxt = " ...Show More";
    var readLessTxt = " Show Less";
    $(".add-read-more.video-para-block").each(function () {
      if ($(this).find(".first-section").length) return;

      var allstr = $(this).text();
      if (allstr.length > carLmt) {
        var firstSet = allstr.substring(0, carLmt);
        var secdHalf = allstr.substring(carLmt, allstr.length);
        var strtoadd =
          firstSet +
          "<span class='second-section'>" +
          secdHalf +
          "</span><span class='read-more'  title='Click to Show More'>" +
          readMoreTxt +
          "</span><span class='read-less' title='Click to Show Less'>" +
          readLessTxt +
          "</span>";
        $(this).html(strtoadd);
      }
    });
    $(document).on("click", ".read-more,.read-less", function () {
      $(this)
        .closest(".add-read-more.video-para-block")
        .toggleClass("show-less-content show-more-content");
    });
  }

  AddReadMore();
});

$(document).ready(function () {
  function AddReadMoreReview() {
    var carLmt = 140;
    var readMoreTxt = " ...Show More";
    var readLessTxt = " Show Less";
    $(".add-review-read-more").each(function () {
      if ($(this).find(".first-section").length) return;

      var allstr = $(this).text();
      if (allstr.length > carLmt) {
        var firstSet = allstr.substring(0, carLmt);
        var secdHalf = allstr.substring(carLmt, allstr.length);
        var strtoadd =
          firstSet +
          "<span class='second-section'>" +
          secdHalf +
          "</span><span class='read-more'  title='Click to Show More'>" +
          readMoreTxt +
          "</span><span class='read-less' title='Click to Show Less'>" +
          readLessTxt +
          "</span>";
        $(this).html(strtoadd);
      }
    });
    $(document).on("click", ".read-more,.read-less", function () {
      $(this)
        .closest(".add-review-read-more")
        .toggleClass("show-less-content show-more-content");
    });
  }

  AddReadMoreReview();
});

$(document).ready(function () {
  function AddReadMoreReview() {
    var carLmt = 140;
    var readMoreTxt = " ...Show More";
    var readLessTxt = " Show Less";
    $(".add-review-read-more").each(function () {
      if ($(this).find(".first-section").length) return;

      var allstr = $(this).text();
      if (allstr.length > carLmt) {
        var firstSet = allstr.substring(0, carLmt);
        var secdHalf = allstr.substring(carLmt, allstr.length);
        var strtoadd =
          firstSet +
          "<span class='second-section'>" +
          secdHalf +
          "</span><span class='read-more'  title='Click to Show More'>" +
          readMoreTxt +
          "</span><span class='read-less' title='Click to Show Less'>" +
          readLessTxt +
          "</span>";
        $(this).html(strtoadd);
      }
    });
    $(document).on("click", ".read-more,.read-less", function () {
      $(this)
        .closest(".add-review-read-more")
        .toggleClass("show-less-content show-more-content");
    });
  }

  AddReadMoreReview();
});

$(document).ready(function () {
  $(".btn-expand").click(function () {
    if ($(".product-des").hasClass("readmore")) {
      $("#expandbtn").html("Show More");
      $(".product-des").removeClass("readmore");
    } else {
      $("#expandbtn").html("Show Less");
      $(".product-des").addClass("readmore");
    }
  });
});

$(document).ready(function () {
  $(".btn-expand").click(function () {
    if ($(".product-des").hasClass("readmore")) {
      $("#expandbtn").html("Show More");
      $(".product-des").removeClass("readmore");
    } else {
      $("#expandbtn").html("Show Less");
      $(".product-des").addClass("readmore");
    }
  });
});

/**********************/

$(document).ready(function () {
  $(".preview-modal").click(function () {
    $("body").addClass("open-modal-contact");
    $("body").addClass("open-modal-thankyou");

    var dataUrl = $(this).data("url");
    var dataname = $(this).data("name");

    if (dataUrl != null) {
      $(".btn-download.card-download").attr("href", dataUrl);
    }
    if (dataname != null) {
      $(".card-title").text(dataname);
    }
  });

  $(".close-contact-modal").click(function () {
    $("body").removeClass("open-modal-contact");
  });
});

/**********************/

$(document).ready(function () {
  $(".download-preview").click(function () {
    $("body").addClass("open-modal-thankyou");
  });

  $(".close-thankyou-modal").click(function () {
    $("body").removeClass("open-modal-thankyou");
  });

  $(".close-thankyou-modal").click(function () {
    $("body").removeClass("open-modal-contact");
  });
});

/******** Customer data send to google sheet *****************/

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

var customerDataElements = document.getElementsByClassName("customerData");
// for (var i = 0; i < customerDataElements.length; i++) {
//     var productName = customerDataElements[i].getAttribute("data-name");
//   console.log(productName);
// }

for (var i = 0; i < customerDataElements.length; i++) {
  customerDataElements[i].addEventListener("click", function () {
    // Get the values from HTML attributes or input fields
    // var previewBtn = document.getElementById("customerTagP").value;
    // var buyBtn = document.getElementById("customerTagB").value;
    // var notifyBtn = document.getElementById("customerTagN").value;

    var productName = document
      .getElementById("customerData")
      .getAttribute("data-name");
    // var productNameN = document.getElementById("customerDataN").getAttribute("data-name");
    // var productNameB = document.getElementById("customerDataB").getAttribute("data-name");

    var customerEmail = document
      .getElementById("customerData")
      .getAttribute("data-email");
    var btnValue = this.getAttribute("data-btnValue");
    console.log(btnValue);
    // Update button values with btnValue
    var previewBtn = "";
    var notifyBtn = "";
    var buyBtn = "";
    if (btnValue == "Preview Now") {
      previewBtn = btnValue;
    } else if (btnValue == "Notify Me") {
      notifyBtn = btnValue;
    } else if (btnValue == "Buy Now") {
      buyBtn = btnValue;
    }

    var previewBtnCookie = previewBtn;
    var buyBtnCookie = buyBtn;
    var notifyBtnCookie = notifyBtn;
    var username = getCookie("username");
    var productName = this.getAttribute("data-name");
    console.log(productName);
    console.log(notifyBtnCookie);
    console.log(previewBtnCookie);
    setCookie("previewButton", previewBtnCookie, 1);
    setCookie("buyButton", buyBtnCookie, 1);
    setCookie("notifyButton", notifyBtnCookie, 1);
    setCookie("productName", productName, 1);
    setCookie("customerEmail", customerEmail, 1);
  });
}

// Google sheet data update
document.addEventListener("DOMContentLoaded", function () {
  var cardDownload = document.getElementById("card-download");
  if (cardDownload) {
    document
      .getElementById("card-download")
      .addEventListener("click", function (event) {
        // Get the values from cookies if they exist, otherwise use the default values from HTML
        previewBtnCookie = getCookie("previewButton");
        productName = getCookie("productName");
        buyBtnCookie = getCookie("buyButton");
        notifyBtnCookie = getCookie("notifyButton");
        customerEmail = getCookie("customerEmail");
        console.log(productName, "207");
        console.log(previewBtnCookie, "207");
        console.log(customerEmail, "207");
        console.log(notifyBtnCookie, "207");
        console.log(buyBtnCookie, "207");

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        const urlencoded = new URLSearchParams();
        urlencoded.append("action", "signup");
        urlencoded.append("productName", productName);
        urlencoded.append("PreviewNow", previewBtnCookie);
        urlencoded.append("NotifyMe", notifyBtnCookie);
        urlencoded.append("email", customerEmail);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: urlencoded,
          redirect: "follow",
        };
        fetch(
          "https://script.google.com/macros/s/AKfycbyPxI24Bn_FNlMEENhFXR-PYnHeo5i2yWpVmNlS4zv5R_8GziKq1h9lSZsHqSqf9TIU/exec",
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => console.log(result))
          .catch((error) => console.error(error));
      });
  }
});

// Newsletter checkbox

var form = document.getElementById("ContactFooter");
var checkbox = document.getElementById("newsletter-checkbox");

if (form && checkbox) {
  form.addEventListener("submit", function (event) {
    if (!checkbox.checked) {
      event.preventDefault();
      alert("Please check the box to subscribe to the newsletter.");
    }
  });
} else {
  console.error("Form or checkbox element not found");
}

// notify me
document.addEventListener("DOMContentLoaded", function () {
  var notifyButton = document.getElementById("customerDataN");
  var buyButton = document.getElementById("customerData");
  var downloadSection = document.getElementById("card-download");
  var closeThankYouModal = document.querySelector(".close-thankyou-modal");
  var closeBodyModal = document.querySelector("body");

  function deleteCookie(name) {
    document.cookie =
      name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  function handleButtonClick(button) {
    var dataTag = button.getAttribute("data-tag");
    localStorage.setItem("productTag", dataTag);
    console.log(dataTag, "dataTag");
    if (dataTag === "Coming Soon") {
      downloadSection.style.display = "none";
    } else {
      downloadSection.style.display = "block";
    }
  }

  if (notifyButton) {
    notifyButton.addEventListener("click", function (event) {
      event.preventDefault();
      console.log("notify btn clicked");
      handleButtonClick(notifyButton);
    });
  }

  if (buyButton) {
    buyButton.addEventListener("click", function (event) {
      event.preventDefault();
      console.log("buy btn clicked");
      handleButtonClick(buyButton);
    });
  }

  var storedTag = localStorage.getItem("productTag");
  if (storedTag && storedTag !== "Coming Soon") {
    downloadSection.style.display = "block";
  } else {
    downloadSection.style.display = "none";
  }

  function clearCookiesOnClose() {
    deleteCookie("previewButton");
    deleteCookie("buyButton");
    deleteCookie("notifyButton");
    deleteCookie("productName");
    deleteCookie("customerEmail");
    console.log("Cookies cleared on modal close.");
  }

  // Attach event listener to close button in the modal
  if (closeThankYouModal) {
    closeThankYouModal.addEventListener("click", function () {
      clearCookiesOnClose(); // Clear cookies
      localStorage.removeItem("productTag");
    });
  }

  // Attach event listener to body click to close modal and clear cookies
  if (closeBodyModal) {
    closeBodyModal.addEventListener("click", function () {
      clearCookiesOnClose(); // Clear cookies
      localStorage.removeItem("productTag");
    });
  }

  // if (closeThankYouModal) {
  //   closeThankYouModal.addEventListener("click", function () {
  //     localStorage.removeItem("productTag");
  //   });
  // }

  // if (closeBodyModal) {
  //   closeBodyModal.addEventListener("click", function () {
  //     localStorage.removeItem("productTag");
  //   });
  // }
});

//new js for read more with para

$(document).ready(function () {
  function AddReadMore() {
    var carLmt = 90;
    var readMoreTxt = " ...Show More";
    var readLessTxt = " Show Less";
    $(".add-read-more.video-para-block p").each(function () {
      if ($(this).find(".first-section").length) return;

      var allstr = $(this).text();
      if (allstr.length > carLmt) {
        var firstSet = allstr.substring(0, carLmt);
        var secdHalf = allstr.substring(carLmt, allstr.length);
        var strtoadd =
          firstSet +
          "<span class='second-section'>" +
          secdHalf +
          "</span><span class='read-more'  title='Click to Show More'>" +
          readMoreTxt +
          "</span><span class='read-less' title='Click to Show Less'>" +
          readLessTxt +
          "</span>";
        $(this).html(strtoadd);
      }
    });
    $(document).on("click", ".read-more,.read-less", function () {
      $(this)
        .closest(".add-read-more.video-para-block p")
        .toggleClass("show-less-content show-more-content");
    });
  }

  AddReadMore();
});

$(document).ready(function () {
  function AddReadMore() {
    var carLmt = 450;
    var readMoreTxt = " ...Show More";
    var readLessTxt = " Show Less";
    $(".add-read-more.threeLine-text").each(function () {
      if ($(this).find(".first-section").length) return;

      var allstr = $(this).text();
      if (allstr.length > carLmt) {
        var firstSet = allstr.substring(0, carLmt);
        var secdHalf = allstr.substring(carLmt, allstr.length);
        var strtoadd =
          firstSet +
          "<span class='second-section'>" +
          secdHalf +
          "</span><span class='read-more'  title='Click to Show More'>" +
          readMoreTxt +
          "</span><span class='read-less' title='Click to Show Less'>" +
          readLessTxt +
          "</span>";
        $(this).html(strtoadd);
      }
    });
    $(document).on("click", ".read-more,.read-less", function () {
      $(this)
        .closest(".add-read-more.threeLine-text")
        .toggleClass("show-less-content show-more-content");
    });
  }

  AddReadMore();
});

/************* Contact Us Dropdown Selection ****************/
document.addEventListener("DOMContentLoaded", function () {
  // Function to get URL parameters
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  // Get the buttonText parameter from the URL
  var buttonText = getUrlParameter("buttonText");

  // Map buttonText values to dropdown values
  var dropdownMapping = {
    "Become A Mentor": "Become a Mentor",
    "Become A Protégé": "Become a Protégé",
    "Book A Demo": "Book a Demo",
  };

  // If buttonText is found in the URL, set the dropdown value
  if (buttonText && dropdownMapping[buttonText]) {
    var selectElement = document.getElementById("contact-us");
    selectElement.value = dropdownMapping[buttonText];
  }
});

/***********video modal js**********/

$(function () {
  $(".popup-youtube, .popup-vimeo").magnificPopup({
    disableOn: 300,
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,

    // This event is triggered when the modal is opened
    callbacks: {
      open: function () {
        $("body").addClass("modal-open-video-box");
      },
      close: function () {
        $("body").removeClass("modal-open-video-box");
      },
    },
  });
});

/**************** wishlist back button ******************/

// Check if the current URL contains 'apps/wishlist'
if (window.location.pathname.includes("apps/wishlist")) {
  console.log("wishlist");
  // Show the back button if the URL matches
  document.getElementById("backButton").style.display = "block";
}

// Add the back function to the button
document.getElementById("backButton").addEventListener("click", function () {
  window.history.back();
});

/*********** Notify Me Klaviyo Btn *****************/

window._klOnsite = window._klOnsite || [];
window._klOnsite.push(["openForm", "TGxKBj"]);

/********* content scroll according to navigation *************/

// Add a click event listener to the navigation menu
document
  .querySelector(".header__inline-menu")
  .addEventListener("click", function (event) {
    // Check if the clicked element is a span within the nav
    if (event.target.classList.contains("header__active-menu-item")) {
      const navText = event.target.textContent.trim();

      const headings = {
        "What's New": document.querySelector("h2.title.inline-richtext.h2"),
        "Coming Soon": document.querySelector("h2.title.inline-richtext.h1"),
      };

      if (headings[navText]) {
        headings[navText].scrollIntoView({
          behavior: "smooth",
        });
        event.preventDefault();
      }
    }
  });

// Select all <a> tags within the footer block
const footerLinks = document.querySelectorAll(
  ".footer-block__details-content a"
);

// Define the mappings for headings
const headings = {
  "What's New": document.querySelector("h2.title.inline-richtext.h2"),
  "Coming Soon": document.querySelector("h2.title.inline-richtext.h1"),
};

// Add click event listeners to each <a> tag
footerLinks.forEach((link) => {
  link.addEventListener("click", function (event) {
    const navText = link.textContent.trim();

    if (headings[navText]) {
      headings[navText].scrollIntoView({
        behavior: "smooth", // Smooth scrolling animation
      });

      // Prevent the default behavior of the link
      event.preventDefault();
    }
  });
});


// Static Page Content
document.addEventListener("DOMContentLoaded", function () {
    const menuLinks = document.querySelectorAll(".menu-link");

    menuLinks.forEach(link => {
        link.addEventListener("click", function (event) {
            const menuValue = this.textContent.trim().toLowerCase();

            // Skip "petition" and "novel"
            if (menuValue === "petition" || menuValue === "novel(nft)") {
                if (menuValue === "novel(nft)") {
                    window.open("https://newintellectual.com/products/why-should-i-get-married", "_blank");
                }
                return;
            }

            event.preventDefault();

            // Convert text to a dynamic ID, e.g. "X-Rated Trailers" → "slider-heading-x-rated-trailers"
            const dynamicId = `slider-heading-${menuValue.replace(/\s+/g, '-')}`;

            const targetElement = document.getElementById(dynamicId);

            console.log(dynamicId, targetElement, "scroll target");

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 80,
                    behavior: "smooth"
                });
            }
        });
    });
});
